<template>
  <div :class="!ishtmlContent || tooltip ? 'description-inline' : 'description-inline-block'" v-if="content || hasSlot" :id="id">
    <template v-if="tooltip">
      <w-tooltip v-if="ishtmlContent">
        <template v-if="hasSlot">
          <slot />
        </template>

        <span v-else v-html="content" />
      </w-tooltip>

      <w-tooltip v-else :tooltip="content" />
    </template>

    <template v-else>
      <span class="description-content" v-if="ishtmlContent">
        <slot v-if="hasSlot" />

        <span v-else v-html="content" />
      </span>

      <span class="description-content" v-else>
        <br v-if="newLine || !tooltip" />
        {{ content }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'w-description',
  props: {
    value: {
      type: String,
      required: false
    },
    model: {
      type: Object,
      required: false
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    htmlContent: {
      type: Boolean,
      default: false
    },
    newLine: {
      type: Boolean,
      default: true
    },
    id: {
      type: [String, Boolean],
      default: false
    }
  },
  computed: {
    content() {
      return this.value || (this.model ? this.model.$schema.description : null);
    },
    hasSlot() {
      return !!this.$slots.default;
    },
    ishtmlContent() {
      return this.htmlContent || this.hasSlot;
    }
  }
};
</script>

<style>
.description-block {
  display: block;
}
.description-inline {
  display: inline;
}
.description-content {
  color: gray;
}
</style>
